/**
 *
 * ButtonStyled
 *
 */
import React, { forwardRef } from 'react';

import { LoaderDots } from 'app/components/LoaderDots';
import { Icon } from 'app/components/Icon';

import { Wrapper, ButtonContent } from './styles';

interface Props {
  variant: string;
  children: React.ReactNode;
  iconRight?: boolean;
  onlyIcon?: boolean;
  loading?: boolean;
  whiteLoader?: boolean;
  onClick?(e?): void;
  hasLeftArrow?: boolean;
  [x: string]: any;
}

export const ButtonStyled = forwardRef(
  (
    {
      variant,
      children,
      iconRight,
      iconLeft,
      onlyIcon,
      loading,
      whiteLoader = true,
      onClick,
      fontSize = '14px',
      hasLeftArrow = false,
      hasRightArrow = false,
      ...props
    }: Props,
    ref: React.Ref<HTMLDivElement>,
  ) => {
    return (
      <Wrapper
        variant={variant}
        onClick={e => {
          e && e.stopPropagation();
          onClick && onClick();
        }}
        {...props}
      >
        <ButtonContent
          mr={hasLeftArrow ? '6px' : iconRight ? 0 : onlyIcon ? 0 : 2}
          ml={iconRight ? 2 : 0}
          fontSize={1}
          ref={ref || null}
          display="flex"
          alignItems="center"
        >
          {loading ? (
            <LoaderDots white={whiteLoader} />
          ) : (
            <>
              {hasLeftArrow && !hasRightArrow && <Icon icon="arrow-left" height="16px" width="16px" />}
              <span>{children}</span>
              {hasRightArrow && !hasLeftArrow && <Icon ml={1} icon="frankie-arrow-right" height="16px" width="16px" />}
            </>
          )}
        </ButtonContent>
      </Wrapper>
    );
  },
);
